import React, { useContext } from 'react'
import HeadingText from '../ActionCommonComponent/HeadingText'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../../../common/Buttons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { AuditTrailViewContext } from '../../AuditTrailViewContext'
import { useS3Data } from '../../../../hooks/useS3Data'

const ModuleAction = () => {
  const navigate = useNavigate();
  const { data: auditTrialData } = useContext(AuditTrailViewContext)
  
  // Use the hook to fetch the JSON from s3URL
  const { data: s3Data } = useS3Data(auditTrialData?.new_content_snapshot)
  
  const version_content = s3Data || auditTrialData?.version_content || {}

  return <>
    <HeadingText heading="Associated Version" text={auditTrialData.version_id}>
    </HeadingText>
    <HeadingText heading="Activity" text={auditTrialData.action}>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <Button
        variant="outline-blue"
        size="sm"
        iconOnly={true}
        icon={<FontAwesomeIcon icon={faArrowRight} />}
        onClick={()=>{
          navigate(`/audit-trail/module-preview/${auditTrialData.audit_trail_id}`)
        }}
      >
      </Button>
    </HeadingText>

    <HeadingText heading="Comment" text={auditTrialData.comment}/>
  </>
}

export default ModuleAction


